document.addEventListener('click', async function(event) {
  const button = event.target.closest('.mj-load-more-button');

  if (!button) return;

  event.preventDefault();

  const nextUrl = button.getAttribute('data-next-url');
  const productListId = button.getAttribute('data-product-list-id');
  const currentProductList = document.getElementById(productListId);

  if (!nextUrl || !productListId || !currentProductList) return;

  button.classList.add('is-loading');
  button.textContent = 'Loading...';

  try {
    const response = await fetch(nextUrl, {
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch next page');
    }

    const text = await response.text();
    const html = new DOMParser().parseFromString(text, 'text/html');

    const newProductList =
      html.getElementById(productListId) ||
      html.querySelector('product-list.product-list') ||
      html.querySelector('.product-list');

    if (!newProductList) {
      throw new Error('Product list not found');
    }

    Array.from(newProductList.children).forEach(function(productCard) {
      productCard.removeAttribute('reveal');
      productCard.removeAttribute('hidden');
      productCard.style.opacity = '1';
      productCard.style.visibility = 'visible';
      productCard.style.transform = 'none';

      currentProductList.appendChild(productCard);
    });

    const newButton = html.querySelector('.mj-load-more-button');

    if (newButton && newButton.getAttribute('data-next-url')) {
      button.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
      button.textContent = 'Load more products';
      button.classList.remove('is-loading');
    } else {
      const wrapper = button.closest('.mj-load-more-wrapper');
      if (wrapper) wrapper.remove();
    }
  } catch (error) {
    console.error('ME & JOE Load More error:', error);
    button.textContent = 'Load more products';
    button.classList.remove('is-loading');
  }
});